import { render, staticRenderFns } from "./VmChangeBootIndex.vue?vue&type=template&id=3c0037c2&scoped=true"
import script from "./VmChangeBootIndex.vue?vue&type=script&lang=js"
export * from "./VmChangeBootIndex.vue?vue&type=script&lang=js"
import style0 from "./VmChangeBootIndex.vue?vue&type=style&index=0&id=3c0037c2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c0037c2",
  null
  
)

export default component.exports